import { render, staticRenderFns } from "./SkillsSection.vue?vue&type=template&id=8f2a80be&scoped=true&"
import script from "./SkillsSection.vue?vue&type=script&lang=js&"
export * from "./SkillsSection.vue?vue&type=script&lang=js&"
import style0 from "./SkillsSection.vue?vue&type=style&index=0&id=8f2a80be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2a80be",
  null
  
)

export default component.exports